<app-navbar></app-navbar>
<div class="container-flex">
    <div class="my-container">
        <div class="section-title-container">
            <div class="row">
                <h3 class="info-title">
                    Usuarios
                    <button class="btn btn-success btn-sm ml-2" data-toggle="modal" data-target="#add-user">
                        Agregar
                    </button>
                    <button class="btn btn-success btn-sm ml-2" (click)="listarUsuarios()">
                        Refrescar tabla
                    </button>
                </h3>
                <button type="button" class="btn btn-outline-dark outline-leer-mas">
                    <a class="nav-link" routerLink="/inicio">Inicio</a>
                </button>
            </div>
        </div>
        <div class="section-body-container">
            <div class="m-5 p-5" *ngIf="!users || !users?.length">

            </div>
            <table class="users-table table table-striped table-borderless table-responsive table-hover"
                *ngIf="users && users?.length">
                <caption class="sr-only">Usuarios</caption>
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Apellido</th>
                        <th scope="col">Correo</th>
                        <th scope="col">Rol</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of users | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize;
                        let i = index;" class="info-text">
                        <th scope="col" [innerText]="i + 1 + ((page - 1) * pageSize)"></th>
                        <td [innerText]="user.name"></td>
                        <td [innerText]="user.lastname"></td>
                        <td [innerText]="user.email"></td>
                        <td [innerText]="user.role"></td>
                        <td class="text-center d-flex">
                            <div class="mr-1">
                                <button class="btn btn-primary btn-sm mt-1" data-toggle="modal" data-target="#view-user"
                                    (click)="$event">
                                    Ver
                                </button>
                            </div>
                            <div class="mr-1">
                                <button class="btn btn-warning btn-sm mt-1" data-toggle="modal"
                                    data-target="#update-user" (click)="$event">
                                    Editar
                                </button>
                            </div>
                            <div>
                                <button class="btn btn-danger btn-sm mt-1" data-toggle="modal"
                                    data-target="#delete-user" (click)="$event">
                                    Eliminar
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ngb-pagination class="d-flex justify-content-center" [collectionSize]="users?.length" [(page)]="page"
                [boundaryLinks]="false" [pageSize]="pageSize" size="sm" [maxSize]="3" [rotate]="true"
                *ngIf="users && users?.length">
            </ngb-pagination>
        </div>
    </div>
</div>
<div class="text-center spinner-container" *ngIf="loading">
    <div class="spinner-border text-primary text-center" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<!---------------------------------------- ADD USER ∆ MODAL ∆ ---------------------------------------->
<div class="modal fade" id="add-user" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="add-user-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #frmAddUser="ngForm" (submit)="$event">
                <div class="modal-header text-center p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="add-user-title">Agregar Usuario</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="$event">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="add-name" class="group-title pb-1">
                            Nombre
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="add-name" #name="ngModel" [(ngModel)]="user.name"
                            name="name" required aria-required="true" [disabled]="isSubmitting" autocomplete="name">
                        <span class="text-danger" *ngIf="frmAddUser?.controls?.name?.touched &&
                            frmAddUser?.controls?.name?.errors?.required">
                            <small>Por favor, ingrese el nombre.</small>
                        </span>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-lastname" class="group-title pb-1">
                            Apellido
                        </label>
                        <input type="text" class="form-control" id="add-lastname" #lastname="ngModel"
                            [(ngModel)]="user.lastname" name="lastname" required aria-required="true"
                            [disabled]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-email" class="group-title pb-1">
                            Correo
                            <small style="color: red;">*</small>
                        </label>
                        <input type="email" class="form-control" id="add-email" #email="ngModel"
                            [(ngModel)]="user.email" name="email" required aria-required="true"
                            [disabled]="isSubmitting" autocomplete="email">
                        <span class="text-danger" *ngIf="frmAddUser?.controls?.email?.touched &&
                            frmAddUser?.controls?.email?.errors?.required">
                            <small>Por favor, ingrese el correo.</small>
                        </span>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-password" class="group-title pb-1">
                            Contraseña
                            <small style="color: red;">*</small>
                        </label>
                        <input type="password" class="form-control" id="add-password" #password="ngModel"
                            [(ngModel)]="user.password" name="password" required aria-required="true"
                            [disabled]="isSubmitting" autocomplete="new-password">
                        <span class="text-danger" *ngIf="frmAddUser?.controls?.password?.touched &&
                            frmAddUser?.controls?.password?.errors?.required">
                            <small>Por favor, ingrese la contraseña.</small>
                        </span>
                    </div>
                    <div class="form-group pb-4">
                        <label for="add-role" class="group-title pb-1">
                            Rol
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="add-role" #role="ngModel" [(ngModel)]="user.role" name="role"
                            required aria-required="true" [disabled]="isSubmitting">
                            <option value="" disabled selected>Seleccione una opción</option>
                            <option [ngValue]="role" *ngFor="let role of userRoles" [innerText]="role"></option>
                        </select>
                        <span class="text-danger" *ngIf="frmAddUser?.controls?.role?.touched &&
                            !frmAddUser?.controls?.role?.errors?.required">
                            <small>Por favor, ingrese el rol.</small>
                        </span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="clearUser()"
                        [disabled]="isSubmitting && frmAddUser.invalid">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary" type="submit" [disabled]="isSubmitting &&
                        frmAddUser.invalid">
                        Agregar Usuario
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!---------------------------------------- UPDATE USER ∆ MODAL ∆ ---------------------------------------->
<div class="modal fade" id="update-user" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="update-user-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #frmUpdateUser="ngForm" (submit)="$event">
                <div class="modal-header text-center p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="update-user-title">Actualizar Usuario</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="$event">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="update-name" class="group-title pb-1">
                            Nombre
                            <small style="color: red;">*</small>
                        </label>
                        <input type="text" class="form-control" id="update-name" #name="ngModel" [(ngModel)]="user.name"
                            name="name" required aria-required="true" [disabled]="isSubmitting" autocomplete="name">
                        <span class="text-danger" *ngIf="frmUpdateUser?.controls?.name?.touched &&
                            frmUpdateUser?.controls?.name?.errors?.required">
                            <small>Por favor, ingrese el nombre.</small>
                        </span>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-lastname" class="group-title pb-1">
                            Apellido
                        </label>
                        <input type="text" class="form-control" id="update-lastname" #lastname="ngModel"
                            [(ngModel)]="user.lastname" name="lastname" required aria-required="true"
                            [disabled]="isSubmitting">
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-email" class="group-title pb-1">
                            Correo
                            <small style="color: red;">*</small>
                        </label>
                        <input type="email" class="form-control" id="update-email" #email="ngModel"
                            [(ngModel)]="user.email" name="email" required aria-required="true"
                            [disabled]="isSubmitting">
                        <span class="text-danger" *ngIf="frmUpdateUser?.controls?.email?.touched &&
                            frmUpdateUser?.controls?.email?.errors?.required">
                            <small>Por favor, ingrese el correo.</small>
                        </span>
                    </div>
                    <div class="form-group pb-4">
                        <label for="update-role" class="group-title pb-1">
                            Rol
                            <small style="color: red;">*</small>
                        </label>
                        <select class="form-control" id="update-role" #role="ngModel" [(ngModel)]="user.role"
                            name="role" required aria-required="true" [disabled]="isSubmitting">
                            <option value="" disabled selected>Seleccione una opción</option>
                            <option [ngValue]="role" *ngFor="let role of userRoles" [innerText]="role"></option>
                        </select>
                        <span class="text-danger" *ngIf="frmUpdateUser?.controls?.role?.touched &&
                            frmUpdateUser?.controls?.role?.errors?.required">
                            <small>Por favor, ingrese el rol.</small>
                        </span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="$event"
                        [disabled]="isUpdating">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-warning" type="submit" [disabled]="isUpdating">
                        Actualizar Usuario
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!---------------------------------------- VIEW USER ∆ MODAL ∆ ---------------------------------------->
<div class="modal fade" id="view-user" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="view-user-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header text-center p-4 bg-dark">
                <h5 class="modal-title group-title w-100 text-white" id="view-user-title">Ver Usuario</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="$event">
                    <span aria-hidden="true" class="text-white">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group pb-4">
                    <label for="view-name" class="group-title pb-1">
                        Nombre
                        <small style="color: red;">*</small>
                    </label>
                    <input type="text" class="form-control" id="view-name" #name="ngModel" [(ngModel)]="user.name"
                        name="name" disabled>
                </div>
                <div class="form-group pb-4">
                    <label for="view-lastname" class="group-title pb-1">
                        Apellido
                    </label>
                    <input type="text" class="form-control" id="view-lastname" #lastname="ngModel"
                        [(ngModel)]="user.lastname" name="lastname" disabled>
                </div>
                <div class="form-group pb-4">
                    <label for="view-email" class="group-title pb-1">
                        Correo
                        <small style="color: red;">*</small>
                    </label>
                    <input type="email" class="form-control" id="view-email" #email="ngModel" [(ngModel)]="user.email"
                        name="email" disabled>
                </div>
                <div class="form-group pb-4">
                    <label for="view-role" class="group-title pb-1">
                        Rol
                        <small style="color: red;">*</small>
                    </label>
                    <input type="text" class="form-control" id="view-role" #role="ngModel" [(ngModel)]="user.role"
                        name="role" disabled>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="$event">
                    Salir
                </button>
            </div>
        </div>
    </div>
</div>

<!---------------------------------------- DELETE USER ∆ MODAL ∆ ---------------------------------------->
<div class="modal fade" id="delete-user" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="delete-user-title" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #frmDeleteUser="ngForm" (submit)="$event">
                <div class="modal-header text-center p-4 bg-dark">
                    <h5 class="modal-title group-title w-100 text-white" id="delete-user-title">Eliminar Usuario</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="$event">
                        <span aria-hidden="true" class="text-white">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group pb-4">
                        <label for="delete-name" class="group-title pb-1">
                            Nombre
                        </label>
                        <input type="text" class="form-control" id="delete-name" [value]="user.name" disabled>
                    </div>
                    <div class="form-group pb-4">
                        <label for="delete-email" class="group-title pb-1">
                            Correo
                        </label>
                        <input type="email" class="form-control" id="delete-email" [value]="user.email" disabled>
                    </div>
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <p class="info-text">
                                ¿Está seguro de que desea eliminar este usuario?
                            </p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="$event"
                        [disabled]="isDeleting">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-sm btn-danger" type="submit" [disabled]="isDeleting">
                        Eliminar
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>